import { ApiKeys, Service } from '../environment';

export const GOOGLE_MAPS_KEY = ApiKeys.get(Service.googleMaps);
